var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixeledInfoContainerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 137,
    viewBox: "0 0 244 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0143 4.78939V1.5H225.116V4.78939V6.28939H226.616H229.462V11.6314V13.1314H230.962H238.154V17.7892V19.2892H239.654H242.5V117.711H239.654H238.154V119.211V123.869H230.962H229.462V125.369V130.026H226.616H225.116V131.526V135.5H18.0143V131.526V130.026H16.5143H14.5377V125.369V123.869H13.0377H5.84585V119.211V117.711H4.34585H1.5V19.2892H4.34585H5.84585V17.7892V13.1314H13.0377H14.5377V11.6314V6.28939H16.5143H18.0143V4.78939Z",
    fill: "white",
    stroke: "#FFC107",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixeledInfoContainerWhite);
export default __webpack_public_path__ + "static/media/pixeled-info-container-white.497139c1bdb5f9bca114f8a6912eb70f.svg";
export { ForwardRef as ReactComponent };